import React from "react";
import styled from "styled-components";
import Banner from "../components/homeComponents/Banner";
import Stats from "../components/homeComponents/Stats";
import LensToWall from "../components/homeComponents/LensToWall";
import BestSelling from "../components/homeComponents/BestSelling";
import PortfolioSection from "../components/homeComponents/PortfolioSection";
import SimpleGallery from "../components/homeComponents/SimpleGallery";
import AIArt from "../components/homeComponents/AIArt";
import Contact from "./Contact";

const Home = () => {
  return (
    <Container>
      <Banner />
      <Stats />
      <LensToWall />
      <BestSelling />
      <PortfolioSection />
      <AIArt />
      <Contact />
    </Container>
  );
};
const Container = styled.div`
  padding: 0;
`;

export default Home;
